import languageList from "../i18n/list";

export const getLanguage = (code) => {
  const language = languageList.find((language) => language.value == code);
  if (!language) return;
  return language.name;
};
